// Styles for ButtonBanner go here.
import { contextualVariable, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledButtonBanner = styled.div`
  .button-container {
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    padding: ${toRem(64)} ${toRem(24)};
    flex-direction: row;
    align-items: flex-start;

    .text-link {
      border-bottom: 0;
      &:focus {
        border-bottom: 0;
      }
      .link-text {
        border-bottom: ${toRem(1)} solid;
      }
    }

    a {
      width: 100%;
      margin-left: 0;
      margin-top: 0;
      display: inline;
      width: fit-content;

      &:not(:first-child) {
        margin-left: ${toRem(24)};
      }

      [dir='rtl'] & {
        margin-left: unset;
        margin-right: 0;

        &:not(:first-child) {
          margin-left: unset;
          margin-right: ${toRem(24)};
        }
      }

      .link-text {
        width: 100%;
        text-align: center;
      }
    }
    .m-link-tertiary-button-external,
    .m-link-tertiary-button {
      [dir='rtl'] & {
        margin-left: ${toRem(24)};
      }
      &:hover,
      &:focus {
        border-bottom: none;
        .link-text {
          border-bottom: ${toRem(1)} solid ${contextualVariable.linkTertiaryButtonColor};
        }
      }
    }
  }

  a {
    position: relative;
  }
  a::after {
    position: absolute;
    left: 100%;
    [dir='rtl'] & {
      left: unset;
      right: 100%;
    }
  }
`;
